<template>
  <v-card>
    <v-card-title>
      <v-text-field v-model="search" label="Search" single-line hide-details></v-text-field>
    </v-card-title>
    <!-- <v-data-table
      :headers="headers"
      :items="faxes"
      :search="search"
    ></v-data-table>-->
    <v-data-table
      :headers="headers"
      :custom-filter="customDataTableItemsFilter"
      :items="faxes"
      :search="search"
      :single-expand="singleExpand"
      :expanded.sync="expanded"
      item-key="_id"
      show-expand
      class="elevation-1"
    >
      <template v-slot:top>
        <!-- <v-toolbar flat>
          <v-toolbar-title>Expandable Table</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-switch v-model="singleExpand" label="Single expand" class="mt-2"></v-switch>
        </v-toolbar> -->
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">OCR {{ item.OCR }}</td>
      </template>
        <template v-slot:item.URL="{ item }">
    <a :href="item.URL" target="item.URL">
      {{ item._id }}
    </a>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import FaxDataService from "../services/FaxDataService";

export default {
  data() {
    return {
      search: "",
      expanded: [],
      singleExpand: false,
      headers: [
        // {
        //   text: "_id",
        //   align: "start",
        //   filterable: true,
        //   value: "_id"
        // },
        { text: "OCR", filterable: true, value: "data-table-expand" },
        { text: "From", value: "From" },
        { text: "URL", value: "URL" },
        { text: "To", value: "To" },
        { text: "TimeStamp", value: "TimeStamp" },
        // { text: "SID", value: "SID" }
      ],
      faxes: []
    };
  },
  methods: {
    retrieveFaxes() {
      FaxDataService.getAll()
        .then(response => {
          this.faxes = response.data;
          console.log(response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },
    customDataTableItemsFilter(value, search, items) {
      /*
      Filter for individual words in search string. Filters
      all object values rather than just the keys included
      in the data table headers.
       */
      const wordArray = search
        .toString()
        .toLowerCase()
        .split(" ")
        .filter(x => x);
      return wordArray.every(word =>
        JSON.stringify(Object.values(items))
          .toString()
          .toLowerCase()
          .includes(word)
      );
    }
  },
  mounted() {
    this.retrieveFaxes();
  }
};
</script>